import ReactPlayer from "react-player";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useGeneralStore } from "hooks/generalesStore";

const VideoModal = () => {
  const { videoAyuda, resetVideoAyuda } = useGeneralStore();

  const handleClose = () => {
    resetVideoAyuda();
  };

  const host = window.location.host;
  return (
    <Dialog
      open={
        videoAyuda && host?.includes("tribunalelectronico.pjedomex.gob.mx")
          ? true
          : false
      }
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="lg"
    >
      <DialogTitle>{videoAyuda?.descAviso}</DialogTitle>
      <DialogContent>
        <ReactPlayer
          loading="lazy"
          url={
            videoAyuda
              ? require(`../../assets/video/${videoAyuda?.link}`)
              : require(`../../assets/video/TUTORIAL_USUARIOS Y POST_SOLICITUD_CITAS.mp4`)
          }
          controls
          width="100%"
          height="100%"
          playing={videoAyuda ? true : false}
          volume={0.8}
          muted={false}
          loop={false}
          pip={false}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VideoModal;
